import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import TableHead from './TableHead';

class TableHeads extends PureComponent {
  render() {
    const { tableHeads, onSort  } = this.props;
    const tableHeadList = tableHeads.map(
      tableHead => <TableHead key={tableHead.id} tableHead={tableHead} onSort={onSort} />,
    );
    return (
      <thead>
        <tr>
          { tableHeadList }          
        </tr>
      </thead>
    );
  }
}

// props validation
TableHeads.propTypes = {
  tableHeads: PropTypes.arrayOf(PropTypes.object),
};

TableHeads.defaultProps = {
  tableHeads: [{
    id: '1',
    name: 'Ticket',
    class: 'w-7',
    prop: 'id'
  }, {
    id: '2',
    name: 'Subject',
    class: 'w-20',
    prop: 'subject'
  }],
};

export default TableHeads;